import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Čišćenje zastarelih localStorage ključeva (migracija na sessionStorage)
const cleanupOldLocalStorage = () => {
  const keysToRemove = ['new_listing_form_data'];
  keysToRemove.forEach(key => {
    if (localStorage.getItem(key)) {
      console.log(`Cleaning up old localStorage key: ${key}`);
      localStorage.removeItem(key);
    }
  });
};
cleanupOldLocalStorage();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
